module.exports = __webpack_public_path__ + "img/考点训练.711f4cb2.png";